import { Link, LinkComponentProps } from '@tanstack/react-router';
import { cn } from '@/lib/utils.ts';

/**
 * `LinkComponentProps`, a nie `CreateLinkProps` — ten drugi jest typem dla
 * komponentu przekazywanego do `createLink()` i ma `to: string`, więc puszczał
 * dowolny sklejony adres.
 */
type CacLinkProps = LinkComponentProps<'a'> & {
  size?: 'm' | 's';
  children?: React.ReactNode;
  className?: string;
};

export const CacLink = ({
  className,
  children,
  size = 'm',
  ...props
}: CacLinkProps) => {
  return (
    <Link
      className={cn(
        'flex items-center justify-start gap-1 text-info-300 transition hover:underline',
        size === 'm' && '[&>svg]:size-5',
        size === 's' && 'text-sm [&>svg]:size-4',
        '[&>svg]:text-base-text',
        className,
      )}
      {...props}
    >
      {children}
    </Link>
  );
};
